import ModalEditTable from '../CRUDUtils/ModalEditTable';
import humanizeString, { capitalizeFirstLetter } from '../../utils'
import { Button, Modal, Dropdown, Menu } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import { isBeforeToday } from '../../utils';
import { useIsAdmin, useIsSuperAdmin, } from '../../store';

import {useMobileStore,useDeploymentListStore, usePaginationStore } from '../../store';
import { useRef, useState, useEffect } from 'react';
import './styles.scss';
import bytes from 'bytes';
import { formatNs } from '../../utils';
import { apiClient } from '../../api_actions';

export function DeploymentsPage() {
  return <DeploymentsPagePrototype only_end_dated={"false"} name={"Deployments"}/>;
}

export function OldDeploymentsPage() {
  return <DeploymentsPagePrototype only_end_dated={"true"} name={"Old Deployments"}/>;
}



function DeploymentsPagePrototype({ only_end_dated, name }) {
  const isMobile = useMobileStore((state) => state.isMobile);
  const [restartEdgeModalVisible, setRestartEdgeModalVisible] = useState(false);
  const [selectedDeploymentForRestart, setSelectedDeploymentForRestart] = useState(null);
  const isAdmin = useIsAdmin();
  const isSuperAdmin = useIsSuperAdmin()
  const tableRef = useRef(null);
  const [rowsExpanded, setRowsExpanded] = useState(false);
  const [actionOptions, setActionOptions] = useState([]);
  const [modalData, setModalData] = useState({ action: null, value: null, record: null });
  const addDeployment = useDeploymentListStore((state) => state.addDeployment);
  const updatePagination = usePaginationStore((state) => state.updatePagination);

  function areCamerasOnline(record) {
    const keys = Object.keys(record.stream_info ?? {});
    const arbitraryKey = keys[0];
    const stream_info = arbitraryKey ? record.stream_info[arbitraryKey] : null;
    let statusClass;
    let statusText;

    if (stream_info?.['PTZ']) {
         return true
    } 
    return false
  }


  const columns = [
    {
      title: 'Tag',
      key: 'combined', // Note: no dataIndex needed
      render: (text, record) => {

          const trailer_tag = record.hardware_info?.tag;
          const uig_tag = record.secondary_hardware_info?.tag;

          if (isMobile) {
            const online = areCamerasOnline(record)
            if (!online) {
              return <span className = "offlinespan">{`${humanizeString(trailer_tag) || 'N/A'}`}</span>;
            }
            return <span>{`${humanizeString(trailer_tag) || 'N/A'}`}</span>;
          }
          return <span>{`${humanizeString(trailer_tag) || 'N/A'} | ${uig_tag || 'N/A'}`}</span>;
      }
    },
    {
      title: 'Project',
      dataIndex: ['project', 'project_name'],
      key: 'project',
      render: (text) => humanizeString(text) || 'N/A',
    },
    {
      title: 'Location',
      dataIndex: ['location', 'name'],
      key: 'location',
      render: (text) => humanizeString(text) || 'N/A',
    },
    {
      title: 'Customer',
      dataIndex: ['project', 'customer', 'name'],
      key: 'customer',
      hideOnMobile: true,
      render: (text) => humanizeString(text) || 'N/A',
    },
    {
      title: 'Owner',
      dataIndex: ['hardware_info', 'owner', 'owner_name'],
      key: 'owner',
      hideOnMobile: true,
      render: (text) => capitalizeFirstLetter(text) || 'N/A',
    },
    {
      title: 'Status',
      key: 'status',
      hideOnMobile: true,
        render: (_, record) => {
          var statusClass = 'status-down';
          var statusText = 'Offline';
          const online = areCamerasOnline(record)

          if (online) {
              statusClass = 'status-healthy';
              statusText = 'Online';
          }

          return (
          <div className='status-wrap' title={statusText}>
            <span className={`status ${statusClass}`}></span> {statusText}
          </div>
        );
        }
    },
    {
      title: 'Compute',
      dataIndex: ['connectivity_info', 'avgrtt'],
      key: 'compute_status',
      hideOnMobile: true,
      hidden:!isSuperAdmin,
      render: (info) => {
        let statusClass;
        let statusText;

         if (info !== 0){
            statusClass = 'status-healthy';
            statusText = 'Online';
         } else {
            statusClass = 'status-down';
            statusText = 'Offline';
         }
        return (
          <div className='status-wrap' title={statusText}>
            <span className={`status ${statusClass}`}></span> {statusText}
          </div>
        );
      },
    },
    {
      title: 'VMS',
      dataIndex: 'deployment_id',
      key: 'deployment_id',
      render: (text, record) => (

        <div>
          <Link to={`/vms/${record.deployment_id}/${record.location.name}`}>VMS</Link>
        </div>
      ),
    },
    {
      title: 'Options',
      key: 'options',
      hideOnMobile: true,
      render: (text, record) => {  // Add 'record' parameter
        const deployment_id = record.deployment_id;
        const location_name = record.location?.name || 'unknown';

        addDeployment({ deployment_id, location_name });

        const items = [
          {
            key: 'schedule',
            label: <Link to={`/schedule/${deployment_id}/${location_name}`}>Schedule</Link>
          },
          {
            key: 'zones',
            label: <Link to={`/zones/${deployment_id}/${location_name}`}>Zones</Link>,
          },
          {
            key: 'notifications',
            label: <Link to={`/notifications/${deployment_id}/${location_name}`}>Notifications</Link>,
          }
        ];

        return (
          <Dropdown menu={{ items }} trigger={['click']}>
            <Button
              type="text"
              icon={<MoreOutlined />}
              onClick={(e) => e.stopPropagation()}
            />
          </Dropdown>
        );
      },
    },
  ].filter(col => col != null && !(isMobile && col.hideOnMobile));

  const formFields = [
    {
      name: 'deployment_id',
      label: 'Deployment',
      type: 'textarea',
      placeholder: 'Deployment ID',
      disabled: true
    },
    {
      name: 'hardware_info',
      label: 'Trailer',
      type: 'select',
      optionsEndpoint: '/read/hardwareinfo?only_base_hw=true',
      filterFn: (item, editingRecord) => {
        // Always show hardware that is not deployed
        if (!item.is_deployed) return true;
        // Also show the trailer currently assigned to the deployment being edited
        const currentHwId = editingRecord?.hardware_info?.hardware_info_id;
        return currentHwId != null && item.hardware_info_id === currentHwId;
      },
      optionsLabel: ['tag'],
      labelSeparator: ' - ',
      optionsValue: 'hardware_info_id',
      searchable: true,
      disabled: !isSuperAdmin,
      rules: [{ required: true, message: 'Must Select a Trailer!' }]
    },
    {
      name: 'location_id',
      label: 'Location',
      type: 'select',
      optionsEndpoint: '/read/locations',
      optionsLabel: ['name'], // Multiple fields!
      labelSeparator: ' - ',  // Optional, defaults to ' - '
      optionsValue: 'location_id',
      searchable: true,
      disabled: !isSuperAdmin,
      rules: [{ required: true }],
    },
    {
      name: 'project_id',
      label: 'Project',
      type: 'select',
      optionsEndpoint: '/read/projects?only_current=true',
      optionsLabel: ['project_name'], // Multiple fields!
      labelSeparator: ' - ',  // Optional, defaults to ' - '
      optionsValue: 'project_id',
      searchable: true,
      disabled: !isSuperAdmin,
      rules: [{ required: true }],
    },
    {
      name: 'unix_start_date',
      label: 'Starting Date',
      type: 'date',  // This makes it a date picker
      placeholder: 'Select starting date',
      disabled: !isSuperAdmin,
      rules: [{ required: true, message: 'Must Select a Starting Date!' }]
    },
    {
      name: 'unix_end_date',
      label: 'Ending Date',
      type: 'date',  // This makes it a date picker
      placeholder: 'Select ending date',
      disabled: !isSuperAdmin,
    },
  ];

  {isSuperAdmin && (
    formFields.push(
      {
        name: 'restart_edge',
        label: 'Restart Periscope',
        type: 'button',
        buttonType: 'default',
        danger: true,
        disabled: !isSuperAdmin,
        onClick: (record) => handleResetEdge(record),
      },
      {
        name: 'config_id',
        label: 'Config',
        type: 'select',
        optionsEndpoint: '/read/configs',
        optionsLabel:['name'],
        optionsValue: 'id',
        rules: [{required: true}],
      },
      {
        name:'failover',
        label: "Failover Available",
        type: 'switch',
        defaultValue: false,   // <-- will be pre-set and included in payload
        disabled: !isSuperAdmin
      }
    )
  )}

  const handleResetEdge = (record) => {
    setSelectedDeploymentForRestart(record);
    setRestartEdgeModalVisible(true);
  };

  const expandedRowRender = (record) => {
    const metadata = record.periscope_metadata?.[record.deployment_id] || {};
    const battery = record.battery_info || {};
    const arbitraryKey = Object.keys(record.stream_info)[0]; // "355"
    const stream_info = record.stream_info[arbitraryKey];
    const connectivity_info = record.connectivity_info || {}
    const weather_report = record.weather_report || {}
    const router_info = record.router_info || {}
    const stream_coverage = record.stream_coverage || {}
    const recording_status = record.recording_status || {}
    const lifetime_coverage = record.lifetime_coverage || {}

    const na = 'N/A';

    const categories = [
      {
        title: 'Disk Info',
        items: [
          { label: 'Free', value: metadata.disk_free ?? na },
          { label: 'Total', value: metadata.disk_total ?? na },
          { label: 'Usage', value: metadata.disk_usage ?? na },
        ],
      },
      {
        title: 'Battery Info',
        items: [
          { label: 'Current', value: battery.current ?? na },
          { label: 'Voltage', value: battery.voltage ?? na },
          { label: 'Charge State', value: battery.charge_state != null ? (battery.charge_state ? 'True' : 'False') : na },
          { label: 'Charger', value: battery.charger_on_off != null ? (battery.charger_on_off ? 'On' : 'Off') : na },
          { label: 'PV Voltage', value: battery.pv_voltage ?? na },
          { label: 'User Yield (kWh)', value: battery.user_yield_kwh ?? na },
        ],
      },
      {
        title: 'Recording',
        items: [
          { label: 'Start', value: record.recording_start ?? na },
          { label: 'End', value: record.recording_end ?? na },
        ],
      },
      {
        title: 'Compute',
        items: [
          { label: 'RAM', value: metadata.RAM ?? na },
          { label: 'VRAM', value: metadata.VRAM ?? na },
          { label: 'FPS', value: metadata.FPS != null ? parseFloat(metadata.FPS).toFixed(2) : na },
          { label: 'Temp (°F)', value: record.internal_temp ?? na },
          { label: 'Power Setting', value: metadata.power_setting ?? na },
        ],
      },
      {
        title: 'Streams',
        items: Object.keys(stream_info).map(key => ({
          label: key,
          value: stream_info[key] != null ? (stream_info[key] ? 'True' : 'False') : na
        }))
      },
      {
        title: 'Network',
        items: [
          { label: 'Avg Latency', value: formatNs(connectivity_info['avgrtt'])},
          { label: 'Min Latency', value: formatNs(connectivity_info['minrtt'])},
          { label: 'Max Latency', value: formatNs(connectivity_info['maxrtt'])},
        ],
      },
      {
        title: 'Weather',
        items: [
          { label: 'Summary', value: weather_report['weather']?.[0]['description'] ?? na },
        ],
      },
      {
        title: 'Data Use',
        items: [
          { label: 'Input', value: bytes.format(router_info['input_bytes'], {unitSeparator: ' '}) ?? na },
          { label: 'Output', value: bytes.format(router_info['output_bytes'], {unitSeparator: ' '}) ?? na },
        ],
      },
    ];

    {isSuperAdmin && (
      categories.push(
          {
            title: 'Weekly Coverage',
            items: Object.keys(stream_coverage).map(key => ({
              label: key,
              value: stream_coverage[key] != null ? parseFloat(stream_coverage[key]).toFixed(2) : na
            }))
          },
          {
            title: 'Total Coverage',
            items: Object.keys(lifetime_coverage).map(key => ({
              label: key,
              value: lifetime_coverage[key] != null ? parseFloat(lifetime_coverage[key]).toFixed(2) : na
            }))
          },
          {
            title: 'Recording Status',
            items: Object.keys(recording_status).map(key => ({
              label: key,
              value: recording_status[key] != null ? (recording_status[key] ? 'True' : 'False') : na
            }))
          },
      )
    )}
    
    return (
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(11, 1fr)', gap: '8px 12px', padding: '8px 12px' }}>
        {categories.map(({ title, items }) => (
          <div key={title}>
            <div style={{ fontWeight: 700, marginBottom: 6, borderBottom: '1px solid #f0f0f0', paddingBottom: 4 }}>{title}</div>
            {items.map(({ label, value }) => (
              <div key={label} style={{ marginBottom: 4 }}>
                <span style={{ fontWeight: 600 }}>{label}: </span>
                <span>{value}</span>
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  };

    const handleConfirmRestartEdge = async () => {
      try {
        if (isSuperAdmin && selectedDeploymentForRestart && selectedDeploymentForRestart.deployment_id) {
          await apiClient.post("update/restart-edge", { deployment_id: selectedDeploymentForRestart.deployment_id });
        }
        setRestartEdgeModalVisible(false);
        setSelectedDeploymentForRestart(null);
      } catch (error) {
        console.error('Failed to restart edge:', error);
      }
    };

  return (
    <div className='container-wrapper'>
      <div className='deployments-header'>
        <h2>{name}</h2>
        <div className='deployments-header-actions'>
          {isAdmin && (
            <>
              <Button
                onClick={() => {
                  if (rowsExpanded) {
                    tableRef.current?.collapseAll();
                  } else {
                    tableRef.current?.expandAll();
                  }
                  setRowsExpanded(prev => !prev);
                }}
              >
                {rowsExpanded ? 'Collapse Rows' : 'Expand Rows'}
              </Button>
              {!isMobile && (
              
              <Button type="primary" onClick={() => tableRef.current?.openAdd()} disabled={!isSuperAdmin}>
                Add New
              </Button>
              )}
            </>
          )}
        </div>
      </div>
      <ModalEditTable
        ref={tableRef}
        createEndpoint="create/deployments"
        readEndpoint="read/deployments"
        editEndpoint="update/deployments"
        deleteEndpoint="delete/deployments"
        columns={columns.filter(col => col != null)}
        formFields={formFields}
        expandedRowRender={isAdmin ? expandedRowRender : null}
        showAddButton={false}
        canDelete={isSuperAdmin && !isMobile}
        canCreate={isSuperAdmin}
        canSave={isSuperAdmin}
        searchQuery="only_end_dated"
        searchInput={only_end_dated}
        rowKey="deployment_id"
        rowClassName={(record) => {
          if (isBeforeToday(record.unix_end_date)) {
            return 'row-red';
          }
          return '';
        }}
      />

      <Modal
        title="Restart Edge"
        open={restartEdgeModalVisible}
        onCancel={() => setRestartEdgeModalVisible(false)}
        onOk={handleConfirmRestartEdge}
        okText="Yes, Restart"
        okButtonProps={{ danger: true }}
        cancelText="Cancel"
      >
        <p>
          Are you sure you want to restart Periscope for <strong>{selectedDeploymentForRestart?.hardware_info?.tag}</strong>?
        </p>
      </Modal>

    </div>
  );
}